import React from 'react';
import MagicForm from '../../Form/MagicForm';
import { ItemScheme } from '../../Form/MagicFormItem';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import { MagicField } from '../../../Enums/MagicField.enum';
import usePatientConsent from '../../PatientProfile/Hooks/usePatientConsent';
import { useMedicalReportDefaultData } from '../../../Modules/MedicalReport/Hooks/useMedicalReportDefaultData';

interface Props {
	onSubmit: (values: FormValues) => void;
	defaultData?: any;
	disableSubmit?: boolean;
	patientId: string;
	isMeddiCase: boolean;
}

const MedicalReportDetailPolandForm: React.FC<Props> = ({
	onSubmit,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);
	const { formDefaultData } = useMedicalReportDefaultData({
		isMeddiCase,
		defaultData,
		isConsentProvided,
	});

	// @ts-ignore
	const handleSubmit = async values => {
		values.diagnosis = values?.diagnosis?.label;
		onSubmit(values);
	};

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.TEXTAREA,
			key: 'reasonForVisit',
			title: 'component.medicalReportDetailPolandForm.reasonForVisit',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'anamnesis',
			title: 'component.medicalReportDetailPolandForm.anamnesis',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXTAREA,
			key: 'examinationFindings',
			title: 'component.medicalReportDetailPolandForm.examinationFindings',
		},
		{
			type: MagicField.DIAGNOSIS_CZECH,
			key: 'diagnosis',
			title: 'component.medicalReportDetailPolandForm.diagnosis',
		},
		{
			type: MagicField.TEXTAREA,
			key: 'recommendationsAndTreatment',
			title:
				'component.medicalReportDetailPolandForm.recommendationsAndTreatment',
		},
	];

	if (isConsentProvided) {
		formScheme.push(
			{
				type: MagicField.WHITESPACE,
			},
			{
				type: MagicField.CHECKBOX,
				key: 'addToPatientECard',
				title: 'component.medicalReport.sendToPatient',
				settings: {
					disabled: isMeddiCase,
				},
			},
		);
	} else {
		formScheme.push(
			{
				type: MagicField.PATIENT_CONSENT_REQUEST,
				settings: {
					patientId,
				},
			},
			{
				type: MagicField.WHITESPACE,
			},
		);
	}

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			defaultValues={formDefaultData}
			disableSubmit={disableSubmit}
		/>
	);
};

export default MedicalReportDetailPolandForm;
